import { render, staticRenderFns } from "./OrganInfoView.vue?vue&type=template&id=19e32fdc&scoped=true"
import script from "./OrganInfoView.vue?vue&type=script&lang=js"
export * from "./OrganInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e32fdc",
  null
  
)

export default component.exports